module.exports = __webpack_public_path__ + "static/media/report-student-filter-fallback.238cce81.svg";